import { Http, Method } from '@ux/drivers';
import { setCookie } from '@uds/cookies';
import { CreateBasket } from 'core/basket';
import makeDriver from 'infrastructure/drivers/json';

const createBasket: CreateBasket = async (brandId: string) => {
  const driver: Http = makeDriver();

  const response = await driver({
    url: '/api/basket/api/v2/baskets',
    method: Method.POST,
    headers: {
      'X-Tenant': brandId,
    },
  });

  const basketId = (await response.body.id) ?? null;
  if (basketId != null) {
    setCookie('basket', basketId);
  }

  return basketId;
};

export default createBasket;
